/**
 * Judge.me : re-scan des widgets d'avis après injection de contenu en AJAX.
 *
 * Les cartes produit injectées après le chargement initial (filtres de collection,
 * quick-add, grille Nosto, slides de carrousel) ne sont pas vues par le scan initial
 * de Judge.me : il faut relancer le rendu des badges à la main.
 *
 * Point de vérité unique : tous les fichiers du thème appellent
 * `window.refreshJudgemeWidgets()`, jamais `jdgm.*` directement.
 *
 * Le loader Judge.me étant chargé en async, la fonction retente quelques fois
 * tant que `window.jdgm` n'est pas prêt, puis abandonne silencieusement.
 */
(function () {
	'use strict';

	var MAX_TRIES = 8;
	var RETRY_DELAY = 500;
	var DEBOUNCE_DELAY = 150;
	var debounceTimer = null;

	function scanJudgeme(tries) {
		var jdgm = window.jdgm;

		if (jdgm && typeof jdgm.batchRenderBadges === 'function') {
			try {
				jdgm.batchRenderBadges();

				// Applique les réglages boutique (textes, couleurs) et démasque les badges.
				if (typeof jdgm.customizeBadges === 'function') {
					jdgm.customizeBadges();
				}
			} catch (error) {
				// Un widget Judge.me qui échoue ne doit jamais casser la page.
			}

			return;
		}

		if (tries < MAX_TRIES) {
			setTimeout(function () {
				scanJudgeme(tries + 1);
			}, RETRY_DELAY);
		}
	}

	window.refreshJudgemeWidgets = function () {
		if (debounceTimer) {
			clearTimeout(debounceTimer);
		}

		debounceTimer = setTimeout(function () {
			scanJudgeme(0);
		}, DEBOUNCE_DELAY);
	};

	/**
	 * Filet de sécurité : si l'app embed « Judge.me Core » est désactivée, le loader
	 * n'a pas d'URL de CDN pour la nouvelle version du widget d'avis et abandonne le
	 * rendu, laissant la version pré-rendue du metafield masquée. On la démasque.
	 */
	function revealLegacyReviewWidgets() {
		if (window.jdgm && window.jdgm.CDN_BASE_URL) {
			return;
		}

		var widgets = document.querySelectorAll('.jdgm-review-widget .jdgm-legacy-widget-content');

		for (var i = 0; i < widgets.length; i++) {
			widgets[i].style.display = '';
		}

		if (widgets.length && window.jdgm && typeof window.jdgm.customizeReviews === 'function') {
			try {
				window.jdgm.customizeReviews();
			} catch (error) {
				// Le widget reste lisible même si l'enrichissement JS échoue.
			}
		}
	}

	// Laisse au loader Judge.me le temps de charger la nouvelle version avant de basculer.
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			setTimeout(revealLegacyReviewWidgets, 1500);
		});
	} else {
		setTimeout(revealLegacyReviewWidgets, 1500);
	}
})();
